var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-todo-button.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-card.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/popover/x-dropdown.js";
import { currentUser } from "@adornis/users/client/currentUser.js";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { switchMap } from "rxjs";
import { AdornisTodo, AdornisTodoStatus } from "../db/AdornisTodo.js";
import "./x-todo-personal-list.js";
var XTodoButton = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._currentUser = new RXController(this, currentUser());
    this._refToggleSubjectFilter = createRef();
    this._numberOfOpenTodos = new RXController(
      this,
      this._currentUser.observable,
      (user$) => user$.pipe(switchMap((user) => AdornisTodo.subscribeNumberOfTodosForUser(user?._id ?? "", AdornisTodoStatus.OPEN)()))
    );
  }
  styles() {
    return [
      ...super.styles(),
      {
        ".dropdown": {
          maxWidth: "50vw",
          minWidth: "300px",
          maxHeight: "70vh"
        }
      }
    ];
  }
  render() {
    return xComponents(html`
      <x-dropdown ${ref(this._refToggleSubjectFilter)} @close=${() => this.requestUpdate()}>
        <x-button
          mode="fab"
          icon="notifications"
          @click=${() => {
      this._refToggleSubjectFilter.value?.toggle();
    }}
        >
          ${this._numberOfOpenTodos.isLoading || !this._numberOfOpenTodos.value ? nothing : html`
                <x-text
                  center
                  ${css({
      position: "absolute",
      paddingTop: "7px",
      textAlign: "center",
      top: "-5px",
      right: "-5px",
      width: "25px",
      height: "25px",
      borderRadius: "50%",
      background: "red",
      color: "white"
    })}
                >
                  ${this._numberOfOpenTodos.value}
                </x-text>
              `}
        </x-button>

        <x-card class="dropdown" slot="dropdown-content">
          <x-todo-personal-list></x-todo-personal-list>
        </x-card>
      </x-dropdown>
    `);
  }
};
__decorateClass([
  state()
], XTodoButton.prototype, "_currentUser", 2);
__decorateClass([
  state()
], XTodoButton.prototype, "_numberOfOpenTodos", 2);
XTodoButton = __decorateClass([
  customElement("x-todo-button")
], XTodoButton);
export {
  XTodoButton
};
